import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon, CloseIcon, ErrorIcon, InfoIcon, WarningIcon } from '@icons';
import classNames from 'classnames';
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import useFocus from '../common/effects/useFocusNew';
import styles from './alert.module.scss';
const Alert = ({ message, height = 100, state = 'info', canDismiss = true, onDismiss, children, RTL = false, focusable = true, size = 'sm', animation = 'shrink', ariaLabelClose = 'close alert', }) => {
    const [close, setClose] = React.useState(false);
    const btnCloseRef = React.useRef(null);
    useFocus(focusable ? btnCloseRef : null, () => setClose(true));
    const style = useMemo(() => ({
        '--height': `${height}px`,
    }), [state]);
    const messageClass = useMemo(() => classNames(styles.alert, {
        [styles[`alert_${state}`]]: true,
        [styles.alert_close]: close,
        [styles.alert_rtl]: RTL,
        [styles[`alert_${size}`]]: true,
        [styles[animation]]: true,
    }), [state, close, animation]);
    const handleClose = useCallback(() => {
        setClose(true);
        onDismiss?.();
    }, []);
    const icon = useMemo(() => {
        switch (state) {
            case 'success':
                return _jsx(CheckIcon, {});
            case 'error':
                return _jsx(ErrorIcon, {});
            case 'warning':
                return _jsx(WarningIcon, {});
            case 'info':
                return _jsx(InfoIcon, {});
            default:
                return _jsx(InfoIcon, {});
        }
    }, []);
    return (_jsxs("div", { className: messageClass, style: style, role: "alert", children: [_jsx("div", { className: styles.alert_icon_wrapper, children: _jsx("span", { className: styles.alert_icon, role: "img", "aria-label": `alert-icon-${state}`, children: icon }) }), _jsx("span", { className: styles.alert_content, children: children || message }), canDismiss && (_jsx("span", { className: styles.alert_close_btn, role: "button", "aria-label": ariaLabelClose, ref: btnCloseRef, onClick: handleClose, tabIndex: focusable ? 0 : -1, children: _jsx(CloseIcon, {}) }))] }));
};
Alert.displayName = 'Alert';
export { Alert };
